export const SET_TARIFFS = 'SET_TARIFFS'
export const RESET_TARIFFS = 'RESET_TARIFFS'
